<template>
  <div class="cb-page__wrapper">
    <template v-if="hp_loaded">
      <template v-if="valid_invoices.length > 0">
        <div class="cb-pheader" id="cb-pheader">
          <paynow-header/>
        </div>
        <div class="cb-pbody">
          <unpaid-invoice/>
        </div>
        <transition name="fade">
          <div class="cb-page__overlay" v-if="set_modal"></div>
        </transition>
        <div class="cb-page__modal" v-if="set_modal">
          <router-view></router-view>
        </div>
      <grecaptcha-text v-if="recaptchaTextEnabled"/>
      </template>
      <template v-else>
        <div class="cb-page__info">
          <i class="icon-info-circle cb-page__info-icon"></i>
          <span class="cb-page__info-text">{{t('no_invoices.txt')}}</span>
        </div>
        <div :style="getRecaptchaTosStyles">
          <grecaptcha-text v-if="recaptchaTextEnabled"/>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="cb-pheader" id="cb-pheader">
        <paynow-header-placeholder/>
      </div>
      <div class="cb-pbody">
        <unpaid-invoice-placeholder/>
      </div>
    </template>
  </div>
</template>
<script type="text/javascript">
import CBNotification from "@/models/cb-notification"
import PaynowHeader from "@/components/collections/headers/PaynowHeader"
import UnpaidInvoice from "./UnpaidInvoice"
import PaynowHeaderPlaceholder from "./PaynowHeaderPlaceholder"
import UnpaidInvoicePlaceholder from "./UnpaidInvoicePlaceholder"
import GrecaptchaText from '@/components/collections/elements/GrecaptchaText'
import RecaptchaUtil from '@/utils/recaptcha'
import {
  mapGetters
} from "vuex"
export default {
  created() {
    this.$store.dispatch('set_hp_token', this.$route.params.token);
    logger.addMetaData("hp_token", this.$route.params.token);
    this.$store.dispatch('fetch_data', this.$route.params.token).catch(error => {
      this.$store.dispatch('set_current_notification', new CBNotification('error', error));
      this.$router.push({name: 'error'});
      logger.e(error);
    });
  },
  beforeRouteEnter(to, from, next) {
    if(to.name != "main") {
      next({name: 'main', params: to.params});
    }
    else {
      next();
    }
  },
  beforeRouteUpdate(to, from, next) {
    if(to.name == 'main'){
      this.$store.dispatch('set_modal',false);
    }
    next();
  },
  computed : {
    ...mapGetters([
      'set_modal',
      'hp_loaded',
      'valid_invoices'
    ]),
    recaptchaTextEnabled() {
      return RecaptchaUtil.isRecaptchaTextEnabled();
    },
    getRecaptchaTosStyles() {
      return {
        'paddingTop': `${ window.innerHeight - 60 }px`
      }
    }
  },
  components: {
  	'paynow-header': PaynowHeader,
    'paynow-header-placeholder' : PaynowHeaderPlaceholder,
    'unpaid-invoice': UnpaidInvoice,
    'unpaid-invoice-placeholder' : UnpaidInvoicePlaceholder,
    'grecaptcha-text': GrecaptchaText,
  }
}
</script>
